unit View.Cst_Ipi.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewCst_IpiList = class(TForm)
    btNew: TButton;
    Cst_IpiDataset: TXDataWebDataSet;
    Cst_IpiDatasetcst_ipi_id: TStringField;
    Cst_IpiDatasetnome: TStringField;
    Cst_IpiDatasetexcluido: TBooleanField;
    Cst_IpiDatasetinclusao: TDateTimeField;
    Cst_IpiDatasetalteracao: TDateTimeField;
    Cst_IpiDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCst_IpiList: TFViewCst_IpiList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCst_IpiList }

procedure TFViewCst_IpiList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewCst_IpiList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCst_IpiList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCst_IpiList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCst_IpiList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCst_IpiList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewCst_IpiList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Cst_IpiDataset.Connection.Model.DefaultSchema.FindEntityType(Cst_IpiDataset.EntitySetName),
      Cst_IpiDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewCst_IpiList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('cst_ipi', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Cst_IpiDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCst_IpiList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.cst_ipi.list.pagination.info');
  btNew := TButton.Create('view.cst_ipi.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.cst_ipi.list.table');
  cbPageSize := TComboBox.Create('view.cst_ipi.list.cbPageSize');
  edSearch := TEdit.Create('view.cst_ipi.list.search');
  lcPaginator := TListControl.Create('view.cst_ipi.list.pagination');
  Cst_IpiDataset := TXDataWebDataSet.Create(Self);
  Cst_IpiDatasetcst_ipi_id := TStringField.Create(Self);
  Cst_IpiDatasetnome := TStringField.Create(Self);
  Cst_IpiDatasetexcluido := TBooleanField.Create(Self);
  Cst_IpiDatasetinclusao := TDateTimeField.Create(Self);
  Cst_IpiDatasetalteracao := TDateTimeField.Create(Self);
  Cst_IpiDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Cst_IpiDataset.BeforeLoadDFMValues;
  Cst_IpiDatasetcst_ipi_id.BeforeLoadDFMValues;
  Cst_IpiDatasetnome.BeforeLoadDFMValues;
  Cst_IpiDatasetexcluido.BeforeLoadDFMValues;
  Cst_IpiDatasetinclusao.BeforeLoadDFMValues;
  Cst_IpiDatasetalteracao.BeforeLoadDFMValues;
  Cst_IpiDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewCst_IpiList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_ipi_id';
      Title := 'cst_ipi_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Cst_IpiDataset.SetParentComponent(Self);
    Cst_IpiDataset.Name := 'Cst_IpiDataset';
    Cst_IpiDataset.EntitySetName := 'Cst_Ipi';
    Cst_IpiDataset.Connection := DMConnection.ApiConnection;
    Cst_IpiDataset.Left := 72;
    Cst_IpiDataset.Top := 144;
    Cst_IpiDatasetcst_ipi_id.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetcst_ipi_id.Name := 'Cst_IpiDatasetcst_ipi_id';
    Cst_IpiDatasetcst_ipi_id.FieldName := 'cst_ipi_id';
    Cst_IpiDatasetcst_ipi_id.Required := True;
    Cst_IpiDatasetcst_ipi_id.Size := 255;
    Cst_IpiDatasetnome.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetnome.Name := 'Cst_IpiDatasetnome';
    Cst_IpiDatasetnome.FieldName := 'nome';
    Cst_IpiDatasetnome.Required := True;
    Cst_IpiDatasetnome.Size := 255;
    Cst_IpiDatasetexcluido.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetexcluido.Name := 'Cst_IpiDatasetexcluido';
    Cst_IpiDatasetexcluido.FieldName := 'excluido';
    Cst_IpiDatasetinclusao.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetinclusao.Name := 'Cst_IpiDatasetinclusao';
    Cst_IpiDatasetinclusao.FieldName := 'inclusao';
    Cst_IpiDatasetalteracao.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetalteracao.Name := 'Cst_IpiDatasetalteracao';
    Cst_IpiDatasetalteracao.FieldName := 'alteracao';
    Cst_IpiDatasetexclusao.SetParentComponent(Cst_IpiDataset);
    Cst_IpiDatasetexclusao.Name := 'Cst_IpiDatasetexclusao';
    Cst_IpiDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Cst_IpiDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Cst_IpiDataset.AfterLoadDFMValues;
    Cst_IpiDatasetcst_ipi_id.AfterLoadDFMValues;
    Cst_IpiDatasetnome.AfterLoadDFMValues;
    Cst_IpiDatasetexcluido.AfterLoadDFMValues;
    Cst_IpiDatasetinclusao.AfterLoadDFMValues;
    Cst_IpiDatasetalteracao.AfterLoadDFMValues;
    Cst_IpiDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
